import '../utils';
import {machinesFromProductionLines, stationsFromProductionLines} from "../utils";
export default {
    productionLines: state => state.productionLines,
    productionLineById: state => id => state.productionLines.find(l => l.id === id),

    stations: state => stationsFromProductionLines(state),
    stationById: state => id => stationsFromProductionLines(state).find(e => e.id === id),

    machines: state => machinesFromProductionLines(),
    machineById: state => id => machinesFromProductionLines(state).find(e => e.id === id),

    machineOperationPivots: state => state.machineOperationPivot,
    machineOperationPivotById: state => id => state.machineOperationPivots.find(m => m.id == id),

    operationGroups: state => state.operationGroups,
    operationGroupById: state => id => state.operationGroups.find(o => o.id == id),

    operationsByOperationGroup: state => operationGroupId => state.operationGroups.find(o => o.id == operationGroupId)?.operations,
    operationById: state => id => state.operationGroups.map(o => o.operations).flat()?.find(o => o.id == id),

    referenceGroups: state => state.referenceGroups,
    referenceGroupById: state => id => state.referenceGroups.find(r => r.id == id),

    references: state => state.references,
    referenceById: state => id => state.references.find(r => r.id == id),

    magnitudeUnits: state => state.magnitudeUnits,
    magnitudeUnitById: state => id => state.magnitudeUnits.find(m => m.id == id),

    packagings: state => state.packagings,
    packagingById: state => id => state.packagings.find(p => p.id == id),

    packagingFormats: state =>  state.packagingFormats,
    packagingFormatById: state => id => state.packagingFormats.find(pf => pf.id == id),

    modals: state => state.modals,
    modalById: state => id => state.modals.find(m => m.id == id),

    userPermissions: state => state.userPermissions,
    userHasPermission: state => permissionName => {
        return state.userPermissions.some(permission => permission.name === permissionName) || state.isUserSuperadmin;
    },

    isUserSuperadmin: state => state.isUserSuperadmin,
    isUserAdmin: state => state.isUserAdmin,
    username: state => state.username,
}
